import React, { useRef, useState } from 'react';
import config from '../../config';
import { contractFileError } from '../documents/contractValidation';
import './documentUploads.css';
import { uploadImage, updateServiceProviderProfile } from '../../Apiservices/Auth/servers/profileServer';

export default function ProviderDocumentsSection({ profile, onUpdated }) {
  const [busy, setBusy] = useState('');
  const [error, setError] = useState('');
  const termsInput = useRef(null), contractInput = useRef(null);
  const upload = async (field, event) => {
    const file = event.target.files?.[0]; event.target.value = '';
    if (!file) return;
    const validationError = contractFileError(file);
    if (validationError) { setError(validationError); return; }
    setBusy(field); setError('');
    try {
      const id = await uploadImage(file);
      if (!id) throw new Error('Upload failed');
      await updateServiceProviderProfile(profile?.id, { [field]: id });
      onUpdated?.({ [field]: id, [field === 'termsFileId' ? 'termsFile' : 'contractFile']: { id, file_name: file.name } });
    } catch (_) { setError('Unable to save this PDF. Please try again.'); }
    finally { setBusy(''); }
  };
  const remove = async (field) => {
    setBusy(field); setError('');
    try { await updateServiceProviderProfile(profile?.id, { [field]: null }); onUpdated?.({ [field]: null }); }
    catch (_) { setError('Unable to remove this PDF. Please try again.'); }
    finally { setBusy(''); }
  };
  const row = (label, field, input) => {
    const file = profile?.[field === 'termsFileId' ? 'termsFile' : 'contractFile'];
    return <div className="profile-document-entry">
      <strong>{label}</strong>
      <input ref={input} type="file" accept=".pdf,application/pdf" hidden onChange={e => upload(field, e)} />
      {profile?.[field] ? <div className="profile-document-row">
        <div className="document-file-label"><span className="document-filename" title={file?.file_name}>{file?.file_name || 'PDF uploaded'}</span></div>
        <details className="document-actions">
          <summary aria-label={label + ' actions'}>&#8942;</summary>
          <div className="document-actions-menu">
            <a href={config.API_BASE_URL + '/gallery/download/' + profile[field] + '?isDownload=false'} target="_blank" rel="noreferrer">View</a>
            <button type="button" disabled={!!busy} onClick={e => { e.currentTarget.closest('details').open = false; input.current.click(); }}>Replace</button>
            <button type="button" disabled={!!busy} onClick={e => { e.currentTarget.closest('details').open = false; remove(field); }}>Remove</button>
          </div>
        </details>
      </div> : <button className="document-upload-button" type="button" disabled={!!busy} onClick={() => input.current.click()}><i className="pi pi-upload" aria-hidden="true" />{busy === field ? 'Uploading...' : 'Upload PDF'}</button>}
    </div>;
  };
  return <section className="profile-documents-section"><h3>Documents</h3><p>Optional PDFs customers can review.</p>{row('Terms & Conditions (PDF)', 'termsFileId', termsInput)}{row('Contract (PDF)', 'contractFileId', contractInput)}{error && <p role="alert">{error}</p>}</section>;
}
